var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_60_963",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_60_963)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 13V3H13V13H11ZM12 21C10.7667 21 9.60417 20.7625 8.5125 20.2875C7.42083 19.8125 6.46667 19.1667 5.65 18.35C4.83333 17.5333 4.1875 16.5792 3.7125 15.4875C3.2375 14.3958 3 13.2333 3 12C3 10.6667 3.275 9.40833 3.825 8.225C4.375 7.04167 5.15 6.01667 6.15 5.15L7.55 6.55C6.75 7.21667 6.125 8.025 5.675 8.975C5.225 9.925 5 10.9333 5 12C5 13.9333 5.68333 15.5833 7.05 16.95C8.41667 18.3167 10.0667 19 12 19C13.95 19 15.6042 18.3167 16.9625 16.95C18.3208 15.5833 19 13.9333 19 12C19 10.9333 18.7792 9.925 18.3375 8.975C17.8958 8.025 17.2667 7.21667 16.45 6.55L17.85 5.15C18.85 6.01667 19.625 7.04167 20.175 8.225C20.725 9.40833 21 10.6667 21 12C21 13.2333 20.7625 14.3958 20.2875 15.4875C19.8125 16.5792 19.1708 17.5333 18.3625 18.35C17.5542 19.1667 16.6042 19.8125 15.5125 20.2875C14.4208 20.7625 13.25 21 12 21Z",
    fill: "#46484A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerSettings);
export default __webpack_public_path__ + "static/media/PowerSettings.b6626411feea1e1a7c2ed9b58695317b.svg";
export { ForwardRef as ReactComponent };